import { Collapse, Tabs } from "antd";
import styles from "./styles.module.scss";
import { tabs } from "./utils";

const { Panel } = Collapse;

interface InventoryOverviewProps {
  hideBg?: boolean;
}

const InventoryOverview: React.FC<InventoryOverviewProps> = ({ hideBg }) => {
  if (hideBg) {
    return (
      <div className={styles.collapseContentStyle}>
        <Tabs type="card" items={tabs} />
      </div>
    );
  }

  return (
    <Collapse
      defaultActiveKey={1}
      className={styles.collapseContentStyle}
      accordion
      ghost
      bordered={false}
    >
      <Panel
        key={1}
        header="Inventory overview"
        className={styles.collapseLabelStyle}
      >
        <Tabs type="card" items={tabs} />
      </Panel>
    </Collapse>
  );
};

export default InventoryOverview;
